import { render } from "./participateAiMining.vue?vue&type=template&id=50e18764&scoped=true"
import script from "./participateAiMining.vue?vue&type=script&lang=js"
export * from "./participateAiMining.vue?vue&type=script&lang=js"

import "./participateAiMining.vue?vue&type=style&index=0&id=50e18764&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e18764"]])

export default __exports__